import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Update({ color = 'icon.primary', strokeWidth = '1.5', ...props }) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        d='M1.97266 11.5077C2.7513 12.7497 3.8584 13.8231 5.88198 14.3803C7.92463 14.9419
         10.1828 14.6838 11.8955 13.4359C13.5188 12.2541 14.4074 10.5692 14.6567 8.8125'
        stroke={color}
        strokeWidth={strokeWidth}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1 6.84509C1.25075 5.08252 2.14523 3.3962 3.76996 2.21578C5.47974 0.973769
         7.73208 0.72302 9.77033 1.28317C11.8027 1.84039 12.9113 2.91084 13.6841 4.14991'
        stroke={color}
        strokeWidth={strokeWidth}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1.70312 14.4405V11.5078H4.63585'
        stroke={color}
        strokeWidth='1.5'
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.9523 1.21875V4.15148H11.0195'
        stroke={color}
        strokeWidth={strokeWidth}
        fill='transparent'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Update.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Update
